/**
 * Design tokens of the Calendall Admin identity: navy chrome, blue primary, hairline borders, dense rows.
 * The MUI theme is derived from these; components reach for a token directly only where the theme has no
 * matching slot (chips, tri-state segments, chart ramps).
 */
export const colors = {
    chrome: "#12325c",
    primary: "#1f5aa8",
    primaryHover: "#12325c",

    ink: "#16202e",
    body: "#3c4a5e",
    muted: "#61708a",
    faint: "#8a97ab",
    placeholder: "#a6b1c2",

    canvas: "#f6f7f9",
    card: "#ffffff",
    tableHeader: "#f2f4f7",
    tableHeaderAlt: "#f8f9fb",
    rowHover: "#f4f8fd",
    navHover: "#eef1f6",

    cardBorder: "#e2e5ea",
    inputBorder: "#cfd6e0",
    rowDivider: "#f2f4f7",
    sectionDivider: "#eef0f4",
    segmentBorder: "#dfe4ec",
    switchTrackOff: "#c3cbd8",

    success: "#1f7a4d",
    successTint: "#e8f3ec",
    warning: "#b95f09",
    warningText: "#95531a",
    warningTint: "#fdf3e8",
    expiring: "#d97727",
    error: "#ba1a1a",
    errorTint: "#fdecec",
    errorPanelBorder: "#f1c9c9",
    errorPanelBackground: "#fdf3f3",
    errorPanelText: "#8c1d1d",
    neutral: "#61708a",
    neutralTint: "#f1f3f6",
    info: "#1f5aa8",
    infoTint: "#eaf1fb",
    exclusive: "#95531a",
    exclusiveTint: "#fdf0e2",

    loginCanvas: "#eceef1",
} as const;

export const chartRamp = ["#12325c", "#1f5aa8", "#6f9bd6", "#c3d4ec"] as const;
export const chartPreviousPeriod = "#b9cdea";
export const chartTrack = "#f2f4f7";

export const fonts = {
    sans: "Roboto, system-ui, -apple-system, \"Segoe UI\", Helvetica, Arial, sans-serif",
    mono: "ui-monospace, Menlo, Consolas, monospace",
} as const;

export const shadows = {
    card: "0 1px 2px rgba(0,0,0,.04)",
    primaryButton: "0 1px 2px rgba(18,50,92,.3)",
    dialog: "0 12px 32px rgba(0,0,0,.28)",
    dropdown: "0 6px 16px rgba(18,50,92,.18)",
} as const;

export const scrim = "rgba(18,50,92,.32)";

export const layout = {
    topBarHeight: 56,
    navWidth: 212,
} as const;

export type ChipTone = "success" | "warning" | "error" | "neutral" | "info" | "exclusive";

export const chipTones: Record<ChipTone, {color: string; background: string}> = {
    success: {color: colors.success, background: colors.successTint},
    warning: {color: colors.warningText, background: colors.warningTint},
    error: {color: colors.error, background: colors.errorTint},
    neutral: {color: colors.neutral, background: colors.neutralTint},
    info: {color: colors.info, background: colors.infoTint},
    exclusive: {color: colors.exclusive, background: colors.exclusiveTint},
};
